import React from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { isMediaLoading } from 'features/product-info';
import { PdpMediaGallery } from 'features/product-info/components/pdp-media-gallery';
import { styles } from 'features/product-info/components/pdp-showcase/styles';
import { jcm } from 'utils';
import { ConnectedProps } from 'types/utils';
import { Containers } from '../styles';

export const DATA_QA_MEDIA_CONTENT = 'media-content_mf-pdp';

export type ProductMediaContentProps = ConnectedProps<typeof mapStoreToProps> &
  React.HTMLAttributes<HTMLElement>;

export const ProductMediaContent: React.FC<ProductMediaContentProps> = ({ mediaIsLoading }) => {
  return (
    <Containers.MediaContent data-qa={DATA_QA_MEDIA_CONTENT} id={DATA_QA_MEDIA_CONTENT}>
      <PdpMediaGallery
        className={jcm({
          [styles.stickyMediaGallery]: true,
          [styles.whenDataIsLoading.noninteractive]: mediaIsLoading,
        })}
      />
    </Containers.MediaContent>
  );
};

export const mapStoreToProps = (store: RootReducer) => ({
  mediaIsLoading: isMediaLoading(store) ?? false,
});

export const ProductMediaContentConnected = connect(mapStoreToProps)(ProductMediaContent);
